import { useEffect } from "react";
import profilePicture from "../MyPhoto/IMG-20231031-WA0000.jpg";
import "../Styles/MyInfo.css";

const MyInfo = () => {
  useEffect(() => {
    const typewriterElements = document.querySelectorAll('.typewriter-line');
    const timeouts = [];
    const intervals = [];
    
    const typeText = (element, text, delay = 0) => {
      return new Promise((resolve) => {
        const startTimeout = setTimeout(() => {
          element.textContent = '';
          element.classList.remove('completed');
          let index = 0;
          
          const typeInterval = setInterval(() => {
            if (index < text.length) {
              element.textContent += text[index];
              index++;
            } else {
              clearInterval(typeInterval);
              element.classList.add('completed');
              resolve();
            }
          }, 80); // 80ms delay between each character for better readability
          intervals.push(typeInterval);
        }, delay);
        timeouts.push(startTimeout);
      });
    };

    const startTypewriter = async () => {
      // Initialize all elements - clear content and hide cursors
      typewriterElements.forEach((el, index) => {
        el.textContent = ''; // Clear any existing content
        el.style.setProperty('--show-cursor', 'none');
        el.classList.remove('completed');
      });

      for (let i = 0; i < typewriterElements.length; i++) {
        const element = typewriterElements[i];
        const text = element.getAttribute('data-text');
        
        // Show cursor on current line
        element.style.setProperty('--show-cursor', 'inline');
        
        await typeText(element, text, 0);
        
        // Hide cursor on completed line and show on next line
        element.style.setProperty('--show-cursor', 'none');
        if (i + 1 < typewriterElements.length) {
          typewriterElements[i + 1].style.setProperty('--show-cursor', 'inline');
        }
        
        // Pause between lines
        await new Promise(resolve => {
          const pauseTimeout = setTimeout(resolve, 300);
          timeouts.push(pauseTimeout);
        });
      }
    };

    // Start the typewriter effect after a short delay
    const kickoff = setTimeout(startTypewriter, 500);
    timeouts.push(kickoff);

    // Safety fallback: if nothing typed after 3s, render full lines immediately
    const fallback = setTimeout(() => {
      if (typewriterElements.length > 0) {
        const first = typewriterElements[0];
        if (first && first.textContent.trim().length === 0) {
          typewriterElements.forEach((el) => {
            const txt = el.getAttribute('data-text') || '';
            el.textContent = txt;
            el.classList.add('completed');
            el.style.setProperty('--show-cursor', 'none');
          });
        }
      }
    }, 3000);
    timeouts.push(fallback);

    // Cleanup on unmount
    return () => {
      timeouts.forEach(clearTimeout);
      intervals.forEach(clearInterval);
      typewriterElements.forEach((el) => {
        el.textContent = '';
        el.classList.remove('completed');
        el.style.setProperty('--show-cursor', 'none');
      });
    };
  }, []);

  return (
    <div className="hero-container">
      <div className="hero-content">
        <div className="hero-text">
          <div className="hero-greeting">
            <span className="greeting-text">Hey, I'm Tank Prasad</span>
          </div>
          
          <div className="hero-main">
            <h1 className="hero-title">
              <span className="typewriter-line" data-text="I enjoy designing">&nbsp;</span><br />
              <span className="typewriter-line" data-text="educational experiences and">&nbsp;</span><br />
              <span className="typewriter-line" data-text="research insights">&nbsp;</span>
            </h1>
            
            <p className="hero-description">
              Passionate about behavioral economics and consumer behavior research. 
              Dedicated to creating exceptional educational experiences that 
              blend innovative teaching with impactful research.
            </p>
            
            <div className="hero-buttons">
              <a href="mailto:tankp.neupane@jgu.edu.in" className="btn-primary">
                Get in touch
              </a>
              <a href="https://www.linkedin.com/in/tank-prasad-neupane-27185198/" target="_blank" rel="noopener noreferrer" className="btn-secondary">
                <svg className="btn-icon" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
                LinkedIn
              </a>
            </div>
          </div>
        </div>
        
        <div className="hero-image">
          <div className="image-container">
            <img 
              className="profile-image" 
              src={profilePicture} 
              alt="Tank Prasad Neupane" 
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default MyInfo;
